import { Bank, CaretLeft, Check, User } from "@phosphor-icons/react";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";

const transferTypes = [
  {
    name: "visaro",
    title: "Verified Visaro User",
    icon: User,
    description: "Send money to another visaro user",
  },
  {
    name: "bank",
    title: "Bank Account",
    icon: Bank,
    description: "Send money to another bank account",
  },
];

const SelectTransferType = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [selectedTransferType, setSelectedTransferType] = useState<
    string | null
  >(null);

  const handleNext = useCallback(() => {
    if (!user?.pin_status) {
      navigate(`/pin/setup?redirect=/send/${selectedTransferType}`);
    } else {
      navigate(`/send/${selectedTransferType}`);
    }
  }, [user, selectedTransferType, navigate]);

  return (
    <div>
      <div className="flex items-center justify-center gap-10 px-5 py-20 text-center flex-col">
        <div className="flex flex-col gap-2">
          <div className="font-semibold text-3xl">Select a transfer type</div>
          <div className="text-gray-500">Choose how you want to send money</div>
        </div>
        <div className="c-groupedSelect c-groupedSelect--vertical">
          {transferTypes.map((type, key) => {
            return (
              <button
                key={key}
                onClick={() => setSelectedTransferType(type.name)}
                className={`c-groupedSelect__option ${
                  selectedTransferType === type.name && "active"
                }`}
              >
                <div className="text-visaro-orange rounded-full p-3 bg-visaro-orange/10">
                  <type.icon weight="bold" size={22} />
                </div>
                <div className="flex-1 flex-col text-left">
                  <div className="text-lg font-medium">{type.title}</div>
                  <div className="text-sm text-gray-700">
                    {type.description}
                  </div>
                </div>
                {selectedTransferType === type.name ? (
                  <div className="bg-visaro-orange p-2 rounded-full">
                    <Check className="text-white" weight="bold" size={16} />
                  </div>
                ) : (
                  <div className=" p-2 rounded-full">
                    <Check
                      className="text-white invisible"
                      weight="bold"
                      size={16}
                    />
                  </div>
                )}
              </button>
            );
          })}
          <br />
          <div className="flex justify-between gap-2">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="p-2 py-3 text-center text-deepBlue border px-6 rounded-xl font-medium flex gap-2 items-center border-gray-300"
            >
              <CaretLeft weight="bold" size={20} />
              <span>Back</span>
            </button>
            <button
              onClick={handleNext}
              disabled={!selectedTransferType}
              className="p-2 py-3 text-center bg-deepBlue text-white px-10 border-2 rounded-xl font-medium"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectTransferType;
